// 特殊返回preventCache作为key，可以禁用缓存，用对象保证唯一性
export const preventCache = Object.create(null);
export default function cache(fn, _thisArg, { resetReject = true, keyFn = (...args) => args.length
    ? args.map((arg) => arg?.toString?.()).join('-')
    : 'default', msMaxAge = 0, } = {}) {
    // 结果缓存结果的map
    let res = {};
    // 结果缓存的时间
    let isCached = {};
    const cachedFn = function (...args) {
        const key = keyFn(...args);
        // @ts-expect-error
        const thisArg = this || _thisArg;
        if (key === preventCache) {
            return fn.apply(thisArg, args);
        }
        // 有缓存，并且在有效期，直接返回缓存结果
        if (isCached[key] &&
            (msMaxAge <= 0 || Date.now() - isCached[key] <= msMaxAge)) {
            return res[key];
        }
        res[key] = fn.apply(thisArg, args);
        isCached[key] = Date.now();
        // 缓存的结果是promise，并且需要在reject的时候去删除缓存，这样重新请求的时候，能正常发请求
        if (resetReject && res[key] && res[key].then && res[key].catch) {
            res[key].catch(() => {
                delete res[key];
                delete isCached[key];
            });
        }
        return res[key];
    };
    // 可以手动清除缓存
    cachedFn.clearCache = function (key) {
        if (typeof key !== 'undefined') {
            delete isCached[key];
            delete res[key];
        }
        else {
            isCached = {};
            res = {};
        }
    };
    return cachedFn;
}
